<template>
	<div class="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
		<label>Class</label>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">Class</span>
			</div>
			<input type="text" class="form-control" v-model="Class" />
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">BAB</span>
			</div>
			<input class="form-control" v-model.number="BAB">
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">Fort</span>
			</div>
			<input class="form-control" v-model.number="Fort">
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">Ref</span>
			</div>
			<input class="form-control" v-model.number="Ref">
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">Will</span>
			</div>
			<input class="form-control" v-model.number="Will">
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">HP</span>
			</div>
			<input class="form-control" v-model.number="HP">
			<div class="input-group-append" v-if="level==1">
				<span class="input-group-text">+ Race</span>
			</div>
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">SP</span>
			</div>
			<input class="form-control" v-model.number="SP">
			<div class="input-group-append">
				<span class="input-group-text">+ CON</span>
			</div>
		</div>
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text class-stat-label">Skills</span>
			</div>
			<input class="form-control" v-model.number="SkillRanks">
			<div class="input-group-append">
				<span class="input-group-text">+ INT</span>
			</div>
		</div>
		<div class="btn-group btn-row d-flex justify-content-between flex-wrap mt-2">
			<button class="btn btn-default flex-fill mx-1 mb-1" v-if="!hasDrone" @click="addDrone(level)"><font-awesome-icon icon="robot"></font-awesome-icon> Add Drone</button>
			<button class="btn btn-danger flex-fill mx-1 mb-1" v-if="hasDrone" @click="removeDrone(level)"><font-awesome-icon icon="robot"></font-awesome-icon> Remove Drone</button>

			<button class="btn btn-default flex-fill mx-1 mb-1" v-if="!hasCompanion" @click="addCompanion(level)"><font-awesome-icon icon="paw"></font-awesome-icon> Add Companion</button>
			<button class="btn btn-danger flex-fill mx-1 mb-1" v-if="hasCompanion" @click="removeCompanion(level)"><font-awesome-icon icon="paw"></font-awesome-icon> Remove Companion</button>

			<button class="btn btn-default flex-fill mx-1 mb-1" v-if="!hasPools" @click="addPools(level)"><font-awesome-icon icon="toolbox"></font-awesome-icon> Add Pools</button>
			<button class="btn btn-danger flex-fill mx-1 mb-1" v-if="hasPools" @click="removePools(level)"><font-awesome-icon icon="toolbox"></font-awesome-icon> Remove Pools</button>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'level',
	],
	methods: {
		value: function(property){
			return this.$store.state.Character.Levels[this.level][property]
		},
		update: function(property, value){
			this.$store.commit('setCharacterProp',[
				{
					key: `Levels[${this.level}].${property}`,
					val: value,
				}
			])
		},
	},
	computed: {
		Class: {
			get: function() {
				return this.value('Class')
			},
			set: function(value){
				this.update('Class',value)
			},
		},
		BAB: {
			get: function() {
				return this.value('BAB')
			},
			set: function(value){
				this.update('BAB',value)
			},
		},
		Fort: {
			get: function() {
				return this.value('Fort')
			},
			set: function(value){
				this.update('Fort',value)
			},
		},
		Ref: {
			get: function() {
				return this.value('Ref')
			},
			set: function(value){
				this.update('Ref',value)
			},
		},
		Will: {
			get: function() {
				return this.value('Will')
			},
			set: function(value){
				this.update('Will',value)
			},
		},
		HP: {
			get: function() {
				return this.value('HP')
			},
			set: function(value){
				this.update('HP',value)
			},
		},
		SP: {
			get: function() {
				return this.value('SP')
			},
			set: function(value){
				this.update('SP',value)
			},
		},
		SkillRanks: {
			get: function() {
				return this.value('SkillRanks')
			},
			set: function(value){
				this.update('SkillRanks',value)
			},
		},
		hasDrone: function(){
			return (this.$store.state.Character.Levels[this.level].Drone)?true:false
		},
		hasCompanion: function(){
			return (this.$store.state.Character.Levels[this.level].Companion)?true:false
		},
		hasPools: function(){
			return (this.$store.state.Character.Levels[this.level].Pools)?true:false
		},
	},
}
</script>

<style scoped>
	.class-stat-label {
		width: 3.75em;
	}
	.flex-fill {
		flex: 1 !important;
	}
</style>